import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=4e92395e&scoped=true"
import script from "./Domains.vue?vue&type=script&lang=ts"
export * from "./Domains.vue?vue&type=script&lang=ts"
import style0 from "./Domains.vue?vue&type=style&index=0&id=4e92395e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92395e",
  null
  
)

export default component.exports